import {
  Navigate,
  Outlet,
  useParams,
  useLocation,
  useOutletContext,
} from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import PageSpinner from "../../components/PageSpinner/PageSpinner";
const ProtectedRoute = () => {
  const isAuth = useAuth();
  const { shop_id } = useParams();
  const location = useLocation();
  // Pass MainLayout's context (shop, reviewType, ...) through to the pages
  const layoutContext = useOutletContext();

  const allowedPaths = [`/${shop_id}/guest`];

  if (allowedPaths.includes(location.pathname)) {
    return <Navigate to={location.pathname} />;
  }

  // Wait for the shop API before entering: shop off / login QR disabled => 404
  if (layoutContext?.shopLoading) return <PageSpinner />;
  if (layoutContext?.shopNotFound) return <Navigate to="/404" replace />;

  return isAuth ? (
    <Outlet context={layoutContext} />
  ) : (
    <Navigate to={`/${shop_id}/login`} />
  );
};

export default ProtectedRoute;
